import React from "react";

const IntegrationIcon = ({ size = 24, color = "#2E3192" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fill={color}
      d="M20 6h-2V3a1 1 0 00-1-1h-2V1h-2v1h-2V1H9v1H7a1 1 0 00-1 1v3H4a1 1 0 00-1 1v2H1v2h2v2H1v2h2v2a1 1 0 001 1h2v3a1 1 0 001 1h2v1h2v-1h2v1h2v-1h2a1 1 0 001-1v-3h2a1 1 0 001-1v-2h1v-2h-1v-2h1V9h-1V7a1 1 0 00-1-1zm-4 14H8V4h8v16z"
    />
  </svg>
);

export default IntegrationIcon;
